export default __webpack_public_path__ + "static/media/login_bg.582c621f.png";